import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractCrudService } from '../../../shared/abstract-crud.service';
import { Comment } from './comment.model';
import { environment } from '../../../../environments/environment';


/**
 * This service is used to display confirm dialogs when requested.
 */
@Injectable()
export class CommentService extends AbstractCrudService<Comment> {

  /**
   * URL for current model, override url from superclass
   * @type {string}
   */
  protected url = environment.regoApiURL + 'notificationcomments';

  /**
   * Default constructor
   * @param {HttpClient} http - Angular Http Client
   */
  constructor(http: HttpClient) {
    super(http);
  }
}
